import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsSurfaceTypeSectionDisplayedParams = {
  is_surface_type_shown: boolean;
  trail_id: string;
};

/**
 * Whether the trail page viewed has the surface type section loaded. Should fire when the user enters the trail details page. This event fires on web only; this information is included in the is_surface_type_shown parameter in the TrailDetailsPage event on mobile.
 * @param params - Attributes to log with the amplitude event
 * @param params.is_surface_type_shown - TRUE if the surface type section is shown in the trail details page
 * @param params.trail_id - the id of the trail viewed by the user
 */
const logTrailDetailsSurfaceTypeSectionDisplayed = (
  { is_surface_type_shown, trail_id }: logTrailDetailsSurfaceTypeSectionDisplayedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details surface type section displayed',
    { 'is surface type shown': is_surface_type_shown, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsSurfaceTypeSectionDisplayed;
